// extracted by mini-css-extract-plugin
export default {"approved":"CardStatus_approved__5Y-Gv","processing":"CardStatus_processing__bvDWg"};